/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddDocumentReferencesToFolderRequest } from '../models/AddDocumentReferencesToFolderRequest';
import type { AdminDelegateDocumentRequest } from '../models/AdminDelegateDocumentRequest';
import type { AIClassification } from '../models/AIClassification';
import type { ClassificationApproval } from '../models/ClassificationApproval';
import type { ClassifyDocument } from '../models/ClassifyDocument';
import type { CompanyDocuments } from '../models/CompanyDocuments';
import type { ConfirmPdfExportUpload } from '../models/ConfirmPdfExportUpload';
import type { CreateOrDeleteDocumentReferenceObject } from '../models/CreateOrDeleteDocumentReferenceObject';
import type { DelegateDocumentRequest } from '../models/DelegateDocumentRequest';
import type { DetailResponse } from '../models/DetailResponse';
import type { DocumentReferenceClassification } from '../models/DocumentReferenceClassification';
import type { DocumentReferenceCreateRequest } from '../models/DocumentReferenceCreateRequest';
import type { DocumentReferenceDeleteResponse } from '../models/DocumentReferenceDeleteResponse';
import type { DocumentReferenceObjectView } from '../models/DocumentReferenceObjectView';
import type { DocumentReferencesView } from '../models/DocumentReferencesView';
import type { DocumentRequestView } from '../models/DocumentRequestView';
import type { FileCreateRequest } from '../models/FileCreateRequest';
import type { FileCreateResponse } from '../models/FileCreateResponse';
import type { FileModel } from '../models/FileModel';
import type { FileUpdate } from '../models/FileUpdate';
import type { FileUpdateRequestedFiles } from '../models/FileUpdateRequestedFiles';
import type { FileView } from '../models/FileView';
import type { FirmDocumentCompaniesResponse } from '../models/FirmDocumentCompaniesResponse';
import type { FirmDocumentFilterOptionsResponse } from '../models/FirmDocumentFilterOptionsResponse';
import type { FirmDocumentFoldersResponse } from '../models/FirmDocumentFoldersResponse';
import type { FirmDocumentMeasurementDatesResponse } from '../models/FirmDocumentMeasurementDatesResponse';
import type { FirmDocumentReference } from '../models/FirmDocumentReference';
import type { FirmDocumentReferenceBulkDeleteRequest } from '../models/FirmDocumentReferenceBulkDeleteRequest';
import type { FirmDocumentReferenceBulkDeleteResponse } from '../models/FirmDocumentReferenceBulkDeleteResponse';
import type { FirmDocumentReferenceTransferRequest } from '../models/FirmDocumentReferenceTransferRequest';
import type { FirmDocumentReferenceTransferResponse } from '../models/FirmDocumentReferenceTransferResponse';
import type { FirmDocumentReferenceUpdateRequest } from '../models/FirmDocumentReferenceUpdateRequest';
import type { FirmDocumentRequestedFilesResponse } from '../models/FirmDocumentRequestedFilesResponse';
import type { FirmDocumentSuggestionsResponse } from '../models/FirmDocumentSuggestionsResponse';
import type { FolderModel } from '../models/FolderModel';
import type { FolderView } from '../models/FolderView';
import type { IndividualRequestedFile } from '../models/IndividualRequestedFile';
import type { MarkRequestedFileFulfillment } from '../models/MarkRequestedFileFulfillment';
import type { RedelegateDocumentRequest } from '../models/RedelegateDocumentRequest';
import type { TaskModel } from '../models/TaskModel';
import type { URL } from '../models/URL';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DocumentsService {
  /**
   * Manually trigger document classification for a file
   * @param data
   * @returns AIClassification
   * @throws ApiError
   */
  public static apiDocumentsClassificationClassifyCreate(
    data: ClassifyDocument,
  ): CancelablePromise<AIClassification> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/classification/classify/',
      body: data,
      errors: {
        400: `Classification failed`,
        404: `File not found`,
      },
    });
  }
  /**
   * List all AI classifications for a specific file.
   * GET /api/documents/classification/file/<file_id>/
   * @param fileId
   * @returns AIClassification
   * @throws ApiError
   */
  public static apiDocumentsClassificationFileRead(
    fileId: string,
  ): CancelablePromise<Array<AIClassification>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/classification/file/{file_id}/',
      path: {
        'file_id': fileId,
      },
    });
  }
  /**
   * List all document references pending auto-classification approval.
   * GET /api/documents/classification/pending/
   * GET /api/documents/classification/pending/?md_id=<measurement_date_id>
   * @returns DocumentReferenceClassification
   * @throws ApiError
   */
  public static apiDocumentsClassificationPendingList(): CancelablePromise<Array<DocumentReferenceClassification>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/classification/pending/',
    });
  }
  /**
   * Approve a document's auto-classification suggestion
   * @param documentReferenceId
   * @param data
   * @returns DocumentReferenceClassification
   * @throws ApiError
   */
  public static apiDocumentsClassificationApproveCreate(
    documentReferenceId: string,
    data: ClassificationApproval,
  ): CancelablePromise<DocumentReferenceClassification> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/classification/{document_reference_id}/approve/',
      path: {
        'document_reference_id': documentReferenceId,
      },
      body: data,
      errors: {
        400: `Document not pending classification approval`,
        404: `Document reference not found`,
      },
    });
  }
  /**
   * Decline a document's auto-classification suggestion
   * @param documentReferenceId
   * @param data
   * @returns DocumentReferenceClassification
   * @throws ApiError
   */
  public static apiDocumentsClassificationDeclineCreate(
    documentReferenceId: string,
    data: ClassificationApproval,
  ): CancelablePromise<DocumentReferenceClassification> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/classification/{document_reference_id}/decline/',
      path: {
        'document_reference_id': documentReferenceId,
      },
      body: data,
      errors: {
        400: `Document not pending classification approval`,
        404: `Document reference not found`,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this measurement date documents.
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsCompanyRead(
    id: number,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<CompanyDocuments>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/company/{id}',
      path: {
        'id': id,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param mdId
   * @param data
   * @returns DocumentReferenceObjectView
   * @throws ApiError
   */
  public static apiDocumentsDocumentReferenceObjectsCreate(
    mdId: string,
    data: CreateOrDeleteDocumentReferenceObject,
  ): CancelablePromise<Array<DocumentReferenceObjectView>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/document-reference-objects/{md_id}',
      path: {
        'md_id': mdId,
      },
      body: data,
    });
  }
  /**
   * Download actual file content from S3 instead of returning a signed URL.
   * Supports both direct file download and base64-encoded response.
   * @param fileId
   * @param versionId
   * @param base64
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsDownloadContentRead(
    fileId: string,
    versionId?: string,
    base64: boolean = false,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/download-content/{file_id}',
      path: {
        'file_id': fileId,
      },
      query: {
        'version_id': versionId,
        'base64': base64,
      },
    });
  }
  /**
   * @param fileId
   * @param versionId Optional version ID of the file to download a specific version (not used since we are not retaining versions ids yet)
   * @param firmId Optional firm ID to specify the firm context for the file download. Used when downloading a firm summary report.
   * @returns any Presigned URL to download the file.
   * @throws ApiError
   */
  public static apiDocumentsDownloadRead(
    fileId: string,
    versionId?: string,
    firmId?: string,
  ): CancelablePromise<{
    signed_url?: string;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/download/{file_id}',
      path: {
        'file_id': fileId,
      },
      query: {
        'version_id': versionId,
        'firm_id': firmId,
      },
    });
  }
  /**
   * @param mdId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFeatureObjectsRead(
    mdId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/feature-objects/{md_id}',
      path: {
        'md_id': mdId,
      },
    });
  }
  /**
   * @param mdPk
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFileUploadRequestRead(
    mdPk: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/file-upload-request/{md_pk}',
      path: {
        'md_pk': mdPk,
      },
    });
  }
  /**
   * @param mdPk
   * @param fileUuid
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFileUploadRequestRead1(
    mdPk: string,
    fileUuid: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/file-upload-request/{md_pk}/{file_uuid}',
      path: {
        'md_pk': mdPk,
        'file_uuid': fileUuid,
      },
    });
  }
  /**
   * @param firmId
   * @param search
   * @param fundId
   * @param ordering
   * @returns FirmDocumentCompaniesResponse
   * @throws ApiError
   */
  public static apiDocumentsFirmsCompaniesList(
    firmId: string,
    search?: string,
    fundId?: number,
    ordering: 'name' | '-name' | 'document_count' | '-document_count' = 'name',
  ): CancelablePromise<FirmDocumentCompaniesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/firms/{firm_id}/companies',
      path: {
        'firm_id': firmId,
      },
      query: {
        'search': search,
        'fund_id': fundId,
        'ordering': ordering,
      },
    });
  }
  /**
   * @param firmId
   * @param data
   * @returns FirmDocumentReferenceBulkDeleteResponse
   * @throws ApiError
   */
  public static apiDocumentsFirmsDocumentReferencesBulkDeleteCreate(
    firmId: string,
    data: FirmDocumentReferenceBulkDeleteRequest,
  ): CancelablePromise<FirmDocumentReferenceBulkDeleteResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/firms/{firm_id}/document-references/bulk-delete',
      path: {
        'firm_id': firmId,
      },
      body: data,
    });
  }
  /**
   * @param firmId
   * @param data
   * @returns FirmDocumentReferenceTransferResponse
   * @throws ApiError
   */
  public static apiDocumentsFirmsDocumentReferencesTransferCreate(
    firmId: string,
    data: FirmDocumentReferenceTransferRequest,
  ): CancelablePromise<FirmDocumentReferenceTransferResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/firms/{firm_id}/document-references/transfer',
      path: {
        'firm_id': firmId,
      },
      body: data,
    });
  }
  /**
   * @param firmId
   * @param documentReferenceId
   * @param data
   * @returns FirmDocumentReference
   * @throws ApiError
   */
  public static apiDocumentsFirmsDocumentReferencesPartialUpdate(
    firmId: string,
    documentReferenceId: string,
    data: FirmDocumentReferenceUpdateRequest,
  ): CancelablePromise<FirmDocumentReference> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/documents/firms/{firm_id}/document-references/{document_reference_id}',
      path: {
        'firm_id': firmId,
        'document_reference_id': documentReferenceId,
      },
      body: data,
    });
  }
  /**
   * @param firmId
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param search
   * @param companyId
   * @param measurementDateId
   * @param measurementDate Visible measurement date in YYYY-MM-DD format for firm-level grouped Documents.
   * @param fundId
   * @param uploadedBy
   * @param fileType
   * @param source
   * @param referenceObjectType
   * @param ordering
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFirmsDocumentsList(
    firmId: string,
    page?: number,
    pageSize?: number,
    search?: string,
    companyId?: number,
    measurementDateId?: number,
    measurementDate?: string,
    fundId?: number,
    uploadedBy?: number,
    fileType?: 'csv' | 'doc' | 'docx' | 'docm' | 'gif' | 'jpeg' | 'jpg' | 'key' | 'md' | 'numbers' | 'pages' | 'pdf' | 'png' | 'ppt' | 'pptx' | 'ppsm' | 'pptm' | 'rtf' | 'txt' | 'xls' | 'xlsx' | 'xlsm' | 'xlsb' | 'zip',
    source?: 'document_request' | 'generation_job' | 'user',
    referenceObjectType?: 'ct' | 'fi' | 'fo' | 'cb' | 'ev' | 'ssv' | 'fio' | 'ma' | 'rs',
    ordering: '-uploaded_date' | 'uploaded_date' | 'filename' | '-filename' | 'company_name' | '-company_name' | 'measurement_date' | '-measurement_date' = '-uploaded_date',
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<FirmDocumentReference>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/firms/{firm_id}/documents',
      path: {
        'firm_id': firmId,
      },
      query: {
        'page': page,
        'page_size': pageSize,
        'search': search,
        'company_id': companyId,
        'measurement_date_id': measurementDateId,
        'measurement_date': measurementDate,
        'fund_id': fundId,
        'uploaded_by': uploadedBy,
        'file_type': fileType,
        'source': source,
        'reference_object_type': referenceObjectType,
        'ordering': ordering,
      },
    });
  }
  /**
   * @param firmId
   * @param search
   * @param companyId
   * @param measurementDateId
   * @param measurementDate Visible measurement date in YYYY-MM-DD format for firm-level grouped Documents.
   * @param fundId
   * @returns FirmDocumentFilterOptionsResponse
   * @throws ApiError
   */
  public static apiDocumentsFirmsDocumentsFilterOptionsList(
    firmId: string,
    search?: string,
    companyId?: number,
    measurementDateId?: number,
    measurementDate?: string,
    fundId?: number,
  ): CancelablePromise<FirmDocumentFilterOptionsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/firms/{firm_id}/documents/filter-options',
      path: {
        'firm_id': firmId,
      },
      query: {
        'search': search,
        'company_id': companyId,
        'measurement_date_id': measurementDateId,
        'measurement_date': measurementDate,
        'fund_id': fundId,
      },
    });
  }
  /**
   * @param firmId
   * @param search
   * @param companyId
   * @param preferredMeasurementDate Visible date to prioritize in suggestions without filtering out other dates.
   * @param fundId
   * @param uploadedBy
   * @param fileType
   * @param source
   * @param referenceObjectType
   * @param limit
   * @returns FirmDocumentSuggestionsResponse
   * @throws ApiError
   */
  public static apiDocumentsFirmsDocumentsSuggestionsList(
    firmId: string,
    search: string,
    companyId?: number,
    preferredMeasurementDate?: string,
    fundId?: number,
    uploadedBy?: number,
    fileType?: 'csv' | 'doc' | 'docx' | 'docm' | 'gif' | 'jpeg' | 'jpg' | 'key' | 'md' | 'numbers' | 'pages' | 'pdf' | 'png' | 'ppt' | 'pptx' | 'ppsm' | 'pptm' | 'rtf' | 'txt' | 'xls' | 'xlsx' | 'xlsm' | 'xlsb' | 'zip',
    source?: 'document_request' | 'generation_job' | 'user',
    referenceObjectType?: 'ct' | 'fi' | 'fo' | 'cb' | 'ev' | 'ssv' | 'fio' | 'ma' | 'rs',
    limit: number = 8,
  ): CancelablePromise<FirmDocumentSuggestionsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/firms/{firm_id}/documents/suggestions',
      path: {
        'firm_id': firmId,
      },
      query: {
        'search': search,
        'company_id': companyId,
        'preferred_measurement_date': preferredMeasurementDate,
        'fund_id': fundId,
        'uploaded_by': uploadedBy,
        'file_type': fileType,
        'source': source,
        'reference_object_type': referenceObjectType,
        'limit': limit,
      },
    });
  }
  /**
   * @param firmId
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param companyId Optional company ID for company-scoped measurement dates.
   * @param search
   * @param uploadedBy
   * @param fileType
   * @param source
   * @param referenceObjectType
   * @param targetDate Measurement date to locate before pagination is applied.
   * @param targetMeasurementDateId Measurement date ID to locate before pagination is applied.
   * @returns FirmDocumentMeasurementDatesResponse
   * @throws ApiError
   */
  public static apiDocumentsFirmsMeasurementDatesList(
    firmId: string,
    page?: number,
    pageSize?: number,
    companyId?: number,
    search?: string,
    uploadedBy?: number,
    fileType?: 'csv' | 'doc' | 'docx' | 'docm' | 'gif' | 'jpeg' | 'jpg' | 'key' | 'md' | 'numbers' | 'pages' | 'pdf' | 'png' | 'ppt' | 'pptx' | 'ppsm' | 'pptm' | 'rtf' | 'txt' | 'xls' | 'xlsx' | 'xlsm' | 'xlsb' | 'zip',
    source?: 'document_request' | 'generation_job' | 'user',
    referenceObjectType?: 'ct' | 'fi' | 'fo' | 'cb' | 'ev' | 'ssv' | 'fio' | 'ma' | 'rs',
    targetDate?: string,
    targetMeasurementDateId?: number,
  ): CancelablePromise<FirmDocumentMeasurementDatesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/firms/{firm_id}/measurement-dates',
      path: {
        'firm_id': firmId,
      },
      query: {
        'page': page,
        'page_size': pageSize,
        'company_id': companyId,
        'search': search,
        'uploaded_by': uploadedBy,
        'file_type': fileType,
        'source': source,
        'reference_object_type': referenceObjectType,
        'target_date': targetDate,
        'target_measurement_date_id': targetMeasurementDateId,
      },
    });
  }
  /**
   * @param firmId
   * @param measurementDateId
   * @param companyId Optional company ID to validate the measurement date belongs to a selected company.
   * @returns FirmDocumentFoldersResponse
   * @throws ApiError
   */
  public static apiDocumentsFirmsMeasurementDatesFoldersList(
    firmId: string,
    measurementDateId: string,
    companyId?: number,
  ): CancelablePromise<FirmDocumentFoldersResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/firms/{firm_id}/measurement-dates/{measurement_date_id}/folders',
      path: {
        'firm_id': firmId,
        'measurement_date_id': measurementDateId,
      },
      query: {
        'company_id': companyId,
      },
    });
  }
  /**
   * @param firmId
   * @param companyId
   * @param measurementDateId
   * @returns FirmDocumentRequestedFilesResponse
   * @throws ApiError
   */
  public static apiDocumentsFirmsRequestedFilesList(
    firmId: string,
    companyId: number,
    measurementDateId: number,
  ): CancelablePromise<FirmDocumentRequestedFilesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/firms/{firm_id}/requested-files',
      path: {
        'firm_id': firmId,
      },
      query: {
        'company_id': companyId,
        'measurement_date_id': measurementDateId,
      },
    });
  }
  /**
   * @param mdPk
   * @param companyId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsHasDocumentsRead(
    mdPk: string,
    companyId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/has-documents/{md_pk}/{company_id}',
      path: {
        'md_pk': mdPk,
        'company_id': companyId,
      },
    });
  }
  /**
   * Create a documents_file record with a DocumentReference in the Exports folder
   * after the client has uploaded a PDF export directly to S3 via a signed URL.
   * @param data
   * @returns FileModel
   * @throws ApiError
   */
  public static apiDocumentsPdfExportConfirmUploadCreate(
    data: ConfirmPdfExportUpload,
  ): CancelablePromise<FileModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/pdf-export/confirm-upload',
      body: data,
    });
  }
  /**
   * @param mdId
   * @param filePk
   * @param data
   * @returns DocumentReferencesView
   * @throws ApiError
   */
  public static apiDocumentsReferenceCreate(
    mdId: string,
    filePk: string,
    data: DocumentReferenceCreateRequest,
  ): CancelablePromise<DocumentReferencesView> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/reference/{md_id}/{file_pk}',
      path: {
        'md_id': mdId,
        'file_pk': filePk,
      },
      body: data,
    });
  }
  /**
   * @param mdId
   * @param filePk
   * @returns DocumentReferenceDeleteResponse
   * @throws ApiError
   */
  public static apiDocumentsReferenceDelete(
    mdId: string,
    filePk: string,
  ): CancelablePromise<DocumentReferenceDeleteResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/documents/reference/{md_id}/{file_pk}',
      path: {
        'md_id': mdId,
        'file_pk': filePk,
      },
    });
  }
  /**
   * @param mdId
   * @param filePk
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsReferenceObjectCreate(
    mdId: string,
    filePk: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/reference_object/{md_id}/{file_pk}',
      path: {
        'md_id': mdId,
        'file_pk': filePk,
      },
    });
  }
  /**
   * @param mdId
   * @param filePk
   * @returns void
   * @throws ApiError
   */
  public static apiDocumentsReferenceObjectDelete(
    mdId: string,
    filePk: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/documents/reference_object/{md_id}/{file_pk}',
      path: {
        'md_id': mdId,
        'file_pk': filePk,
      },
    });
  }
  /**
   * @param documentReferenceId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsReferencesRead(
    documentReferenceId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/references/{document_reference_id}',
      path: {
        'document_reference_id': documentReferenceId,
      },
    });
  }
  /**
   * GET /api/documents/<document_reference_id>/parser-results/
   * Returns a presigned URL for the parser results JSON stored on the source PDF File.
   * The JSON contains per-page word positions used by the PDF citation layer.
   * @param documentReferenceId
   * @returns URL
   * @throws ApiError
   */
  public static apiDocumentsReferencesParserResultsRead(
    documentReferenceId: string,
  ): CancelablePromise<URL> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/references/{document_reference_id}/parser-results/',
      path: {
        'document_reference_id': documentReferenceId,
      },
    });
  }
  /**
   * @param data
   * @returns DocumentRequestView
   * @throws ApiError
   */
  public static apiDocumentsRequestCreate(
    data: DocumentRequestView,
  ): CancelablePromise<DocumentRequestView> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/request',
      body: data,
    });
  }
  /**
   * @param data
   * @returns IndividualRequestedFile
   * @throws ApiError
   */
  public static apiDocumentsRequestedFileCreate(
    data: IndividualRequestedFile,
  ): CancelablePromise<IndividualRequestedFile> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/requested-file',
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this requested file.
   * @param data
   * @returns IndividualRequestedFile
   * @throws ApiError
   */
  public static apiDocumentsRequestedFileUpdate(
    id: number,
    data: IndividualRequestedFile,
  ): CancelablePromise<IndividualRequestedFile> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/documents/requested-file/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this requested file.
   * @param data
   * @returns IndividualRequestedFile
   * @throws ApiError
   */
  public static apiDocumentsRequestedFilePartialUpdate(
    id: number,
    data: IndividualRequestedFile,
  ): CancelablePromise<IndividualRequestedFile> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/documents/requested-file/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this requested file.
   * @returns void
   * @throws ApiError
   */
  public static apiDocumentsRequestedFileDelete(
    id: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/documents/requested-file/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * Analyst endpoint to mark a requested file N/A or not available.
   * @param id A unique integer value identifying this requested file.
   * @param data
   * @returns MarkRequestedFileFulfillment
   * @throws ApiError
   */
  public static apiDocumentsRequestedFileFulfillmentPartialUpdate(
    id: number,
    data: MarkRequestedFileFulfillment,
  ): CancelablePromise<MarkRequestedFileFulfillment> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/documents/requested-file/{id}/fulfillment',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * After each successful upload (to bucket) we hit this endpoint to create File and DocumentReference objects,
   * to update the RequestedFile status, and check if the entire task is done.
   * @param documentRequestId
   * @param hmacToken
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsRequestsFileUploadStatusCreate(
    documentRequestId: string,
    hmacToken: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/requests/file-upload-status/{document_request_id}/{hmac_token}',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
      },
    });
  }
  /**
   * Return current delegation status for the document request.
   * @param taskId
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsRequestsTaskAppDelegateList(
    taskId: string,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<AdminDelegateDocumentRequest>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/requests/task/{task_id}/app-delegate',
      path: {
        'task_id': taskId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * Admin-level delegation endpoint.
   * @param taskId
   * @param data
   * @returns AdminDelegateDocumentRequest
   * @throws ApiError
   */
  public static apiDocumentsRequestsTaskAppDelegateCreate(
    taskId: string,
    data: AdminDelegateDocumentRequest,
  ): CancelablePromise<AdminDelegateDocumentRequest> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/requests/task/{task_id}/app-delegate',
      path: {
        'task_id': taskId,
      },
      body: data,
    });
  }
  /**
   * @param documentRequestId
   * @param hmacToken
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsRequestsValidateTokenRead(
    documentRequestId: string,
    hmacToken: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/requests/validate-token/{document_request_id}/{hmac_token}',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
      },
    });
  }
  /**
   * Allows a portal user to delegate their document request to another person.
   * No login required - uses HMAC token authentication.
   * @param documentRequestId
   * @param hmacToken
   * @param data
   * @returns DelegateDocumentRequest
   * @throws ApiError
   */
  public static apiDocumentsRequestsDelegateCreate(
    documentRequestId: string,
    hmacToken: string,
    data: DelegateDocumentRequest,
  ): CancelablePromise<DelegateDocumentRequest> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/requests/{document_request_id}/{hmac_token}/delegate',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
      },
      body: data,
    });
  }
  /**
   * Portal (HMAC) endpoint to mark a requested file N/A or not available.
   * @param documentRequestId
   * @param hmacToken
   * @param requestedFileId
   * @param data
   * @returns MarkRequestedFileFulfillment
   * @throws ApiError
   */
  public static apiDocumentsRequestsFulfillmentPartialUpdate(
    documentRequestId: string,
    hmacToken: string,
    requestedFileId: string,
    data: MarkRequestedFileFulfillment,
  ): CancelablePromise<MarkRequestedFileFulfillment> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/documents/requests/{document_request_id}/{hmac_token}/fulfillment/{requested_file_id}',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
        'requested_file_id': requestedFileId,
      },
      body: data,
    });
  }
  /**
   * Allows a portal user to re-delegate (reassign) an existing delegation to a different person.
   * This soft-deletes the old delegation and all its descendants, then creates a new delegation.
   * No login required - uses HMAC token authentication.
   * @param documentRequestId
   * @param hmacToken
   * @param data
   * @returns RedelegateDocumentRequest
   * @throws ApiError
   */
  public static apiDocumentsRequestsRedelegateCreate(
    documentRequestId: string,
    hmacToken: string,
    data: RedelegateDocumentRequest,
  ): CancelablePromise<RedelegateDocumentRequest> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/requests/{document_request_id}/{hmac_token}/redelegate',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
      },
      body: data,
    });
  }
  /**
   * @param documentRequestId
   * @param hmacToken
   * @param mdPk
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsRequestsSignedUrlRead(
    documentRequestId: string,
    hmacToken: string,
    mdPk: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/requests/{document_request_id}/{hmac_token}/signed-url/{md_pk}',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
        'md_pk': mdPk,
      },
    });
  }
  /**
   * @param documentRequestId
   * @param hmacToken
   * @param taskId
   * @param data
   * @returns TaskModel
   * @throws ApiError
   */
  public static apiDocumentsRequestsTaskStatusUpdate(
    documentRequestId: string,
    hmacToken: string,
    taskId: string,
    data: TaskModel,
  ): CancelablePromise<TaskModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/documents/requests/{document_request_id}/{hmac_token}/task-status/{task_id}',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
        'task_id': taskId,
      },
      body: data,
    });
  }
  /**
   * @param documentRequestId
   * @param hmacToken
   * @param taskId
   * @param data
   * @returns TaskModel
   * @throws ApiError
   */
  public static apiDocumentsRequestsTaskStatusPartialUpdate(
    documentRequestId: string,
    hmacToken: string,
    taskId: string,
    data: TaskModel,
  ): CancelablePromise<TaskModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/documents/requests/{document_request_id}/{hmac_token}/task-status/{task_id}',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
        'task_id': taskId,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this file.
   * @param data
   * @returns FileUpdateRequestedFiles
   * @throws ApiError
   */
  public static apiDocumentsUpdateRequestedFileUpdate(
    id: number,
    data: FileUpdateRequestedFiles,
  ): CancelablePromise<FileUpdateRequestedFiles> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/documents/update-requested-file/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this file.
   * @param data
   * @returns FileUpdateRequestedFiles
   * @throws ApiError
   */
  public static apiDocumentsUpdateRequestedFilePartialUpdate(
    id: number,
    data: FileUpdateRequestedFiles,
  ): CancelablePromise<FileUpdateRequestedFiles> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/documents/update-requested-file/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param docsId
   * @param data
   * @returns DocumentReferencesView
   * @throws ApiError
   */
  public static apiDocumentsAddToFolderCreate(
    docsId: string,
    data: AddDocumentReferencesToFolderRequest,
  ): CancelablePromise<Array<DocumentReferencesView>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/{docs_id}/add-to-folder',
      path: {
        'docs_id': docsId,
      },
      body: data,
    });
  }
  /**
   * @param docsId
   * @param data
   * @returns FileCreateResponse
   * @throws ApiError
   */
  public static apiDocumentsFilesCreate(
    docsId: string,
    data: FileCreateRequest,
  ): CancelablePromise<FileCreateResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/{docs_id}/files',
      path: {
        'docs_id': docsId,
      },
      body: data,
    });
  }
  /**
   * @param docsId
   * @param fileId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFilesRead(
    docsId: string,
    fileId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/{docs_id}/files/{file_id}',
      path: {
        'docs_id': docsId,
        'file_id': fileId,
      },
    });
  }
  /**
   * @param docsId
   * @param fileId
   * @param data
   * @returns FileView
   * @throws ApiError
   */
  public static apiDocumentsFilesUpdate(
    docsId: string,
    fileId: string,
    data: FileUpdate,
  ): CancelablePromise<FileView> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/documents/{docs_id}/files/{file_id}',
      path: {
        'docs_id': docsId,
        'file_id': fileId,
      },
      body: data,
    });
  }
  /**
   * @param docsId
   * @param fileId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFilesPartialUpdate(
    docsId: string,
    fileId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/documents/{docs_id}/files/{file_id}',
      path: {
        'docs_id': docsId,
        'file_id': fileId,
      },
    });
  }
  /**
   * @param docsId
   * @param fileId
   * @returns DetailResponse
   * @throws ApiError
   */
  public static apiDocumentsFilesDelete(
    docsId: string,
    fileId: string,
  ): CancelablePromise<DetailResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/documents/{docs_id}/files/{file_id}',
      path: {
        'docs_id': docsId,
        'file_id': fileId,
      },
    });
  }
  /**
   * @param docsId
   * @param fileId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFilesVersionsRead(
    docsId: string,
    fileId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/{docs_id}/files/{file_id}/versions',
      path: {
        'docs_id': docsId,
        'file_id': fileId,
      },
    });
  }
  /**
   * @param docsId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFolderCreate(
    docsId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/{docs_id}/folder',
      path: {
        'docs_id': docsId,
      },
    });
  }
  /**
   * @param docsId
   * @param folderId
   * @returns FolderView
   * @throws ApiError
   */
  public static apiDocumentsFolderRead(
    docsId: string,
    folderId: string,
  ): CancelablePromise<FolderView> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/{docs_id}/folder/{folder_id}',
      path: {
        'docs_id': docsId,
        'folder_id': folderId,
      },
    });
  }
  /**
   * @param docsId
   * @param folderId
   * @param data
   * @returns FolderModel
   * @throws ApiError
   */
  public static apiDocumentsFolderUpdate(
    docsId: string,
    folderId: string,
    data: FolderModel,
  ): CancelablePromise<FolderModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/documents/{docs_id}/folder/{folder_id}',
      path: {
        'docs_id': docsId,
        'folder_id': folderId,
      },
      body: data,
    });
  }
  /**
   * @param docsId
   * @param folderId
   * @param data
   * @returns FolderView
   * @throws ApiError
   */
  public static apiDocumentsFolderPartialUpdate(
    docsId: string,
    folderId: string,
    data: FolderView,
  ): CancelablePromise<FolderView> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/documents/{docs_id}/folder/{folder_id}',
      path: {
        'docs_id': docsId,
        'folder_id': folderId,
      },
      body: data,
    });
  }
  /**
   * @param docsId
   * @param folderId
   * @returns void
   * @throws ApiError
   */
  public static apiDocumentsFolderDelete(
    docsId: string,
    folderId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/documents/{docs_id}/folder/{folder_id}',
      path: {
        'docs_id': docsId,
        'folder_id': folderId,
      },
    });
  }
  /**
   * @param mdId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsReferencesRead1(
    mdId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/{md_id}/references',
      path: {
        'md_id': mdId,
      },
    });
  }
  /**
   * @param mdPk
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsRead(
    mdPk: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/{md_pk}',
      path: {
        'md_pk': mdPk,
      },
    });
  }
}
